import {
  HovercardContextProvider,
  HovercardScopedContextProvider
} from "./5DA3HK6G.js";
import {
  createStoreContext
} from "./CFEUKV6C.js";

// src/tooltip/tooltip-context.tsx
var ctx = createStoreContext(
  [HovercardContextProvider],
  [HovercardScopedContextProvider]
);
var useTooltipContext = ctx.useContext;
var useTooltipScopedContext = ctx.useScopedContext;
var useTooltipProviderContext = ctx.useProviderContext;
var TooltipContextProvider = ctx.ContextProvider;
var TooltipScopedContextProvider = ctx.ScopedContextProvider;

export {
  useTooltipContext,
  useTooltipScopedContext,
  useTooltipProviderContext,
  TooltipContextProvider,
  TooltipScopedContextProvider
};
